export const spanishTranslation = {
  'Les lignes de commandes ont été mises à jour avec succès !':
    'Las líneas de pedidos se han actualizado correctamente.',
  'Le texte a été enregistré avec succès':
    'El texto se ha registrado correctamente',
  'La traduction a été enregistrée avec succès':
    'La traducción ha sido guardada con éxito',
  'Texte + Traduction enregistré avec succès':
    'Texto + Traducción ha sido guardada con éxito',
  'Nombre de mots': 'Número de palabras',
  Lingala: 'Lingala',
  'Prénom/Nom du client': 'Nombre y apellidos del cliente',
  Bashkir: 'Bashkir',
  "La date doit être ultérieure à aujourd'hui.":
    'La fecha debe ser posterior a hoy.',
  'Contenu rédigé': 'Contenido escrito',
  'Nom/prénom': 'Apellido/nombre',
  'Mot de passe incorrect': 'Contraseña incorrecta',
  Institutions: 'Instituciones',
  'Veuillez donner un descriptif au document téléchargé':
    'Por favor, describa el documento descargado',
  'Sichuan Yi ; Nuosu': 'Sichuan Yi; Nuosu',
  Suivant: 'Siguiente',
  Kannada: 'Kannada',
  'Séparer les mots clés par un "enter"':
    'Separe las palabras clave con un "enter".',
  Allemand: 'Alemán',
  Sango: 'Sango',
  'Min.': 'Min.',
  'un email contenant un lien de réinitialisation du mot de passe a été envoyé à votre email':
    'se ha enviado a su correo electrónico un mensaje con un enlace para restablecer la contraseña',
  'Chef edito': 'Redactor jefe',
  Croate: 'Croata',
  'Nb de textes': 'Nº de textos',
  Violet: 'Violeta',
  'Ce champs doit être sup ou égale nombre de texte':
    'Este campo debe ser mayor o igual que el número de texto',
  'a été activé avec succès': 'se ha activado correctamente',
  Népalais: 'Nepalés',
  'Nombre de FAQ': 'Número de preguntas frecuentes',
  Urdu: 'Urdu',
  'Analyses restantes': 'Análisis pendientes',
  Indonésien: 'Indonesia',
  Breton: 'Bretón',
  Livrés: 'Entregado',
  Associations: 'Asociaciones',
  'Le client': 'El cliente',
  'Révision demandée': 'Revisión solicitada',
  "Une erreur s'est produite, veuillez réessayer":
    'Se ha producido un error, inténtelo de nuevo',
  'Mise à jour non autorisée car des textes ont été livrés':
    'Actualización no autorizada al entregar los textos',
  "Pour ajouter un texte (optimisation d'un contenu existant)":
    'Para añadir texto (optimización del contenido existente)',
  Gaélique: 'Gaélico',
  'La ligne de commande pour': 'La línea de comandos para',
  'Business/Management': 'Empresa/Gestión',
  Serbe: 'Serbio',
  "Merci d'indiquer ci-dessous vos demandes de modifications en prenant bien en compte nos conditions de repasses":
    'Indique a continuación sus solicitudes de modificación, teniendo en cuenta nuestras condiciones de planchado',
  'rédacteurs trouvés': 'redactores encontrados',
  'Kirghiz ; Kirghiz': 'Kirguís; Kirguís',
  Différence: 'Diferencia',
  'en cours': 'en curso',
  'Sami du Nord': 'Sami septentrional',
  Comparer: 'Compara',
  Lituanien: 'Lituania',
  'Typix - Mon tableau de bord': 'Typix - Mi panel de control',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial et ne pas être identique au nom':
    'Debe tener al menos 8 caracteres con una letra mayúscula, un número, un carácter especial y no ser idéntico al nombre',
  Webmaster: 'Webmaster',
  'Veuillez saisir des champs valides': 'Introduzca campos válidos',
  Basque: 'Vasco',
  'Exporter .csv': 'Exportar .csv',
  'Confirmer le nouveau mot de passe': 'Confirmar nueva contraseña',
  "Pas d'options": 'Sin opciones',
  'Banque/Assurance': 'Banca/Seguros',
  'Vos demandes': 'Sus peticiones',
  'Coût d\u2019achat': 'Coste de compra',
  Tamil: 'Tamil',
  'Le texte a été supprimé avec succès':
    'El texto se ha eliminado correctamente',
  'Mes Commandes': 'Mis pedidos',
  Zoulou: 'Zulú',
  Afficher: 'Ver',
  Texte: 'Texto',
  Islandais: 'Islandia',
  Russe: 'Ruso',
  'Tous les textes': 'Todos los textos',
  Czech: 'Checa',
  'Comparaison hors ligne': 'Comparación offline',
  Téléphonie: 'Telefonía',
  'Valider le texte': 'Validar el texto',
  'Votre text ne de doit pas dépasser 500 mots':
    'Su texto no debe superar las 500 palabras',
  'Coquilles (double espace, « s »\u2026)': 'Conchas (doble espacio, "s"...)',
  'le consultant': 'el consultor',
  Coréen: 'Coreano',
  'Nb de Silo': 'Nº de silos',
  Validés: 'Validado',
  'non attribuées': 'sin asignar',
  Néerlandais: 'Holandés',
  'Voulez-vous vraiment supprimer': '¿De verdad quieres borrar',
  Rundi: 'Rundi',
  Regional: 'Regional',
  'Compte client': 'Cuenta cliente',
  Global: 'Global',
  'Tous les rôles': 'Todas las funciones',
  Musique: 'Música',
  Perso: 'Personal',
  Kinyarwanda: 'Kinyarwanda',
  'Il semblerait que tu n\u2019aies plus de crédit d\u2019analyse':
    'Parece que no tiene más crédito de análisis',
  Bambara: 'Bambara',
  Sortir: 'Fuera',
  optionel: 'opcional',
  'Temps restant': 'Tiempo restante',
  Ukrainien: 'Ucraniano',
  'Chichewa ; Chewa ; Nyanja': 'Chichewa; Chewa; Nyanja',
  'Votre demande de révision a bien été envoyée.':
    'Su solicitud de revisión ha sido enviada.',
  'Typix - Créer rédacteur': 'Typix - Crear un redactor',
  "n'existe pas": 'no existe',
  Hindi: 'Hindi',
  'ne peut pas être supprimé car il est lié à des sites web':
    'no puede suprimirse, ya que está vinculado a sitios web',
  'Commandes en cours': 'Pedidos en curso',
  'Textes livrés': 'Textos entregados',
  Validation: 'Validación',
  'Non attribuées': 'No asignado',
  'Voulez-vous vraiment désactiver': '¿Realmente desea desactivar',
  'Catalan ; Valencien': 'Catalán; Valenciano',
  'Nombre de textes restants': 'Número de textos restantes',
  'Ne doit pas contenir votre nom': 'No debe contener su nombre',
  Documentation: 'Documentación',
  Kazakh: 'Kazajstán',
  'Numéro invalide': 'Número no válido',
  'Veuillez saisir un texte ou importer un fichier.':
    'Introduzca un texto o importe un archivo.',
  'Nb de FAQ': 'Nº de FAQ',
  Analyser: 'Analice',
  Turc: 'Turco',
  'Toute demande n\u2019ayant pas été précisée lors du brief':
    'Cualquier solicitud no especificada en el escrito',
  Wallon: 'Valonia',
  Birmane: 'Birmano',
  Irlandais: 'Irlandés',
  Oriya: 'Oriya',
  'Réinitialiservotre mot de passe': 'Restablecer contraseña',
  Cuisine: 'Cocina',
  'Haïtien ; créole haïtien': 'Haitiano; Criollo haitiano',
  'Vous ne pouvez pas supprimer le rédacteur': 'No puede eliminar el redactor',
  Validé: 'Validado',
  "cet email n'existe pas": 'este correo electrónico no existe',
  Historique: 'Historia',
  Confirmer: 'Confirme',
  'à cocher si le nombre de mots est différent par texte':
    'marcar si el número de palabras es diferente por texto',
  'Fiche du site web ': 'Ficha del sitio web',
  Désactiver: 'Desactivar',
  'Travaux/BTP': 'Obras/Construcción',
  'La fiche du website': 'La ficha del sitio web',
  'Si le contenu ne respecte pas les règles du brief':
    'Si el contenido no respeta las normas del escrito',
  Norvégien: 'Noruega',
  '0 rédacteurs': '0 redactores',
  indisponible: 'no disponible',
  Venda: 'Venda',
  Maori: 'Maorí',
  'Textes revisés': 'Textos revisados',
  'Status texte': 'Estado del texto',
  'textes livrés en attente de validation':
    'textos entregados en espera de validación',
  'Typix - Mon Profile': 'Typix - Mi perfil',
  'le client': 'el cliente',
  Romanche: 'Romanche',
  'URL du site': 'URL del sitio',
  'nouvelles notifications': 'nuevas notificaciones',
  'Divehi ; Dhivehi ; Maldivien': 'Divehi; Dhivehi; Maldivo',
  'Êtes vous sur de vouloir sauvegarder le texte':
    '¿Estás seguro de que quieres guardar el texto',
  'Veuillez ajouter un texte initiale afin de pouvoir sauvegarder le texte en brouillon':
    'Añada un texto inicial para guardar el texto como borrador',
  Xhosa: 'Xhosa',
  'Le contrat pour le client': 'El contrato para el cliente',
  rédacteurs: 'redactores',
  'Ce champ est obligatoire': 'Este campo es obligatorio',
  'Tarif/Mot': 'Tasa/Palabra',
  Tadjik: 'Tayiko',
  'Réf devis': 'Presupuesto de referencia',
  'Rechercher un rédacteur': 'Buscar un redactor',
  Albanais: 'Albanés',
  Galicien: 'Gallego',
  Disponibilité: 'Disponibilidad',
  'Les deux mots de passe ne sonts pas identiques':
    'Las dos contraseñas no son idénticas',
  Tibétain: 'Tibetano',
  'Typix - Gestion des utilisateurs': 'Typix - Gestión de usuarios',
  'Ossétien ; Ossétique': 'Osetia; osetia',
  Tswana: 'Tswana',
  'Ajouter un client': 'Añadir un cliente',
  'Séparez les mots-clés par un " Enter ".':
    'Separe las palabras clave con una "Intro".',
  'Zhuang ; Chuang': 'Zhuang; Chuang',
  Thématiques: 'Temas',
  'Nb mots/texte': 'Número de palabras/texto',
  Commerce: 'Comercio',
  'Voir les commandes': 'Ver los pedidos',
  'Nombre de mots par texte': 'Número de palabras por texto',
  'Lien drive...': 'Unidad de enlace...',
  'Hollandais ; Flamand': 'Neerlandés; Flamenco',
  'Mon profil': 'Mi perfil',
  "Ce champs doit être sup à 0 car facturation n'est pas au réel":
    'Este campo debe ser mayor que 0 porque la facturación no es real',
  'Le texte a été validé avec succès': 'El texto se ha validado correctamente',
  Jeux: 'Juegos',
  'Voulez-vous vraiment supprimer la ligne de commande pour':
    '¿Realmente desea eliminar la línea de comandos para',
  'Ndebele, Nord ; Ndebele Nord': 'Ndebele, Norte; Ndebele Norte',
  'Slave ecclésiastique ; vieux slavon ; slavon ecclésiastique ; vieux bulgare ; vieux slavon ecclésiastique':
    'Eslavo eclesiástico; Eslavo antiguo; Eslavo eclesiástico; Búlgaro antiguo; Eslavo eclesiástico antiguo',
  Swahili: 'Swahili',
  Voyage: 'Viajar',
  'Nombre de mot à ajouter': 'Número de palabras a añadir',
  'Liste des rédacteurs': 'Lista de redactores',
  'le rédacteur': 'el redactor',
  Kanuri: 'Kanuri',
  rédacteur: 'redactor',
  Tatar: 'Tártaro',
  'Roumain ; Moldave ; Moldovan': 'Rumano; moldavo',
  'Le texte initial de': 'El texto original del',
  'Mail clients': 'Correo del cliente',
  'Le contrat de': 'El contrato de',
  'au moins une lettre minuscule et une lettre majuscule,un caractère spécial et un chiffre':
    'al menos una letra minúscula y una mayúscula, un carácter especial y un número',
  Transport: 'Transporte',
  'Nombre total de mots (existants et ajoutés) :':
    'Número total de palabras (existentes y añadidas) :',
  'Rechercher par mail, prénom, nom, site...':
    'Búsqueda por correo electrónico, nombre, apellidos, sitio...',
  'Nombre de mot à ajouter (Min/Max) : ':
    'Número de palabras a añadir (Mín/Máx) :',
  Compte: 'Cuenta',
  'Tourisme/Loisirs': 'Turismo/Ocio',
  'Nouveau texte': 'Nuevo texto',
  Max: 'Max',
  'Kalaallisut ; Groenlandais': 'Kalaallisut; groenlandés',
  'Oups...!il y a une/plusieurs erreur(s) dans la fenêtre du gap sémantique. Veuillez vérifier son contenu pour la/les corriger et soumettre à nouveau votre texte.':
    'Hay uno o más errores en la ventana de brecha semántica. Compruebe su contenido para corregirlo y vuelva a enviar el texto.',
  'ne peut pas être supprimé pour le moment':
    'no se puede eliminar en este momento',
  'Le texte': 'El texto',
  URL: 'URL',
  "Un utilisateur existe déjà avec l'email":
    'Ya existe un usuario con la dirección de correo electrónico',
  Cree: 'Cree',
  Prénom: 'Nombre',
  'commandes prête': 'pedidos listos',
  Réinitialiser: 'Restablecer',
  'Veuillez fournir une date valide': 'Indique una fecha válida',
  'Kuanyama ; Kwanyama': 'Kuanyama; Kwanyama',
  'Luxembourgeois ; Letzeburgesch': 'Luxemburgués; Letzeburgesch',
  Suédois: 'Sueco',
  'Confirmer le mot de passe': 'Confirmar contraseña',
  'Ce champs est obligatoire et ne peut avoir que des nombres':
    'Este campo es obligatorio y sólo puede contener números',
  Sciences: 'Ciencia',
  Tchétchène: 'Chechenia',
  "est le seul client pour un site, il faut ajouter d'autres pour pouvoir le supprimer":
    'es el único cliente de un sitio, hay que añadir otros para eliminarlo',
  'Le mot de passe de confirmation ne correspond pas':
    'La contraseña de confirmación no coincide',
  Swati: 'Swati',
  Danois: 'Danés',
  Sauvegarder: 'Guardar',
  'Veuillez changer les informations suivantes titre et/ou mot clé':
    'Modifique la siguiente información: título y/o palabra clave',
  'importer un document': 'importar un documento',
  Maltais: 'Maltés',
  'Nb de mots': 'Número de palabras',
  'Les données fournies sont invalides':
    'Los datos proporcionados no son válidos',
  'Livraison estimée': 'Entrega estimada',
  'Grec moderne (1453-)': 'Griego moderno (1453-)',
  Avestan: 'Avestan',
  Inuktitut: 'Inuktitut',
  'Nombre total de mots ajoutés': 'Número total de palabras añadidas',
  'le contenu présente des inexactitudes':
    'el contenido contiene inexactitudes',
  Finnois: 'En finés',
  'Ajouter un admin': 'Añadir un administrador',
  'Min/Max': 'Mín/Máx',
  'Modifier le consultant': 'Modificar el consultor',
  'Liste des clients': 'Lista de clientes',
  'Nom client': 'Nombre del cliente',
  Vert: 'Verde',
  'Mots clés manquants': 'Palabras clave que faltan',
  Lao: 'Lao',
  Somali: 'Somalí',
  'Nb de silo par texte': 'Número de silos por texto',
  Italien: 'Italiano',
  'La commande a été mis à jour avec succès !':
    'El pedido se ha actualizado correctamente.',
  Bosniaque: 'Bosnia',
  'Thématiques d\u2019expertise': 'Temas de especialización',
  'Ce mot de passe est le mot de passe que vous avez oublié':
    'Esta es la contraseña que has olvidado',
  'a été désactivé avec succès': 'se ha desactivado correctamente',
  Kongo: 'Kongo',
  'Postuler à la commande': 'Solicitar la orden',
  'mot-clé': 'palabra clave',
  Abkhazien: 'Abjasia',
  Mongolien: 'Mongolia',
  'Typix - Fiche site web': 'Typix - Sitio web',
  'Mail envoyé': 'Correo enviado',
  Géorgien: 'Georgiano',
  'Si des phrases ne sont pas dans un français correct':
    'Si las frases no están en francés correcto',
  'En cours': 'En curso',
  voir: 'véase',
  "Date d'ajout": 'Fecha añadida',
  'Tarif au mot': 'Tarifa por palabra',
  Thai: 'Tailandés',
  'Détails du texte': 'Detalles del texto',
  'Commandes en retard': 'Pedidos tardíos',
  disponible: 'disponible',
  Droit: 'Ley',
  Azerbaïdjanais: 'Azerbaiyán',
  'Ajouter un consultant': 'Añadir un consultor',
  'Dans le cadre d\u2019une repasse sur des contenus, seuls les éléments suivants seront pris en charge':
    'Al reproducir contenidos, sólo se admitirán los siguientes elementos',
  'doit comprendre au moins 8 charactères':
    'debe contener al menos 8 caracteres',
  'Titre de la commande': 'Título de la orden',
  'Langues bihari': 'Lenguas bihari',
  'Livraison estimé au': 'Entrega estimada para',
  "Le nombre de texte de la commande ne peut pas être inférieur aux nombre de textes attribuées au(x) rédacteur(s). Veuillez d'abord modifier les informations de la ligne de commande":
    'El número de textos de la orden no puede ser inferior al número de textos asignados al redactor o redactores. Por favor, cambie primero la información en la línea de comandos',
  'Date de livraison': 'Fecha de entrega',
  'Voulez-vous vraiment supprimer le contrat de':
    '¿De verdad quieres abolir la',
  'Facturation au réel': 'Facturación real',
  'Gap sémantique': 'Brecha semántica',
  Estonien: 'Estonia',
  Wolof: 'Wolof',
  'Coût d\u2019achat max/mot': 'Coste máximo de compra/palabra',
  'Détail de la commande': 'Detalles del pedido',
  'Export en cours de téléchargement\u2026':
    'Se está cargando la exportación...',
  'Ce champ est obligatoire et doit être inférieur ou égal au Nombre total des textesde la commande':
    'Este campo es obligatorio y debe ser inferior o igual al Número total de textos del pedido',
  Arabe: 'Árabe',
  Bislama: 'Bislama',
  'Mail client': 'Correo del cliente',
  '(Titre, mot clé, url, balise, méta-description)':
    '(Título, palabras clave, url, etiqueta, meta-descripción)',
  'Typix - Nouvelle commande': 'Typix - Nuevo pedido',
  'Révision en attente': 'Revisión pendiente',
  'Le consultant': 'El asesor',
  Entreprise: 'Empresa',
  Aragonais: 'Aragonesa',
  Kashmiri: 'Cachemira',
  'a été activé': 'se ha activado',
  'Interlingua (Association internationale des langues auxiliaires)':
    'Interlingua (Asociación Internacional de Lenguas Auxiliares)',
  Actualités: 'Noticias',
  'Votre décision a été prise en compte avec succès':
    'Su decisión ha sido tenida en cuenta',
  Afrikaans: 'Afrikaans',
  'contenu en attente de vérification client':
    'contenido pendiente de verificación por el cliente',
  'Fiche du rédacteur': 'Archivo del redactor',
  Outillage: 'Herramientas',
  'Typix - Détails de la commande': 'Typix - Detalles del pedido',
  'Ajouter ou compléter ci-dessous votre contenu :':
    'Añada o complete su contenido a continuación:',
  Ewe: 'Ewe',
  'contenu en attente de repasse rédacteur':
    'contenido pendiente redactor de repeticiones',
  'La commande a été supprimé avec succès':
    'El pedido se ha eliminado correctamente',
  'Expressions ou phrases françaises mais ne vous convenant pas':
    'Expresiones o frases en francés que no le convienen',
  Corse: 'Córcega',
  Modifier: 'Editar',
  'Nb de GMB': 'Nº de GMB',
  Oromo: 'Oromo',
  Polish: 'Polaco',
  'Insérez votre gap sémantique avec l’occurrence':
    'Inserte su hueco semántico con la ocurrencia',
  'Nb de textes à optimiser': 'Número de textos que deben optimizarse',
  Mode: 'Modo',
  Akan: 'Akan',
  'Révisions effectués': 'Revisiones realizadas',
  'Modifier l\u2019admin': 'Editar el admin',
  'Télécharger le document': 'Descargar el documento',
  Hausa: 'Hausa',
  'Notes rédacteurs': 'Notas de los redactores',
  Quechua: 'Quechua',
  Féroïen: 'Feroés',
  'Modifier le rédacteur': 'Cambiar el redactor',
  Mail: 'Correo',
  Rédacteurs: 'redactores',
  'Typix - Détails du texte': 'Typix - Detalles del texto',
  Hongrois: 'Húngaro',
  'Bon pour livraison': 'Bueno para la entrega',
  'Au réel': 'En el mundo real',
  'Hiri Motu': 'Hiri Motu',
  Hébreu: 'Hebreo',
  'Nombre total de mots ajoutés :': 'Número total de palabras añadidas :',
  Komi: 'Komi',
  'Doit être inférieur au nombre maximum': 'Debe ser inferior al número máximo',
  'Nom du texte': 'Nombre del texto',
  'Ajouter un rédacteur': 'Añadir un redactor',
  Ou: 'O',
  Utilisateurs: 'Usuarios',
  Heures: 'Horas',
  'Santé/Bien-être': 'Salud/Bienestar',
  'Interlingue ; Occidental': 'Interlingüe; Occidental',
  'Luba-Katanga': 'Luba-Katanga',
  Letton: 'Letón',
  Anglais: 'Inglés',
  Envoyer: 'Enviar',
  'Tableau de bord': 'Cuadro de mandos',
  'Demande de révision': 'Solicitud de revisión',
  'Résultat sémantique': 'Resultado semántico',
  'Chercher un rédacteur': 'Buscar un redactor',
  'Ce champs est obligatoire': 'Este campo es obligatorio',
  Rédaction: 'redactorial',
  'Modifier le client': 'Modificar el cliente',
  'Voulez-vous vraiment supprimer le rédacteur':
    '¿Realmente quieres borrar el redactor',
  Titre: 'Título',
  Langue: 'Idioma',
  'Mot clé': 'Palabras clave',
  'Les demandes suivantes ne seront pas prises en compte':
    'No se tendrán en cuenta las siguientes solicitudes',
  'délai dépassé': 'plazo incumplido',
  Tchouvache: 'Tchouvache',
  Ganda: 'Ganda',
  Twi: 'Twi',
  'Contrat déjà existant, veuillez modifier les informations':
    'Contrato existente, modifique la información',
  Igbo: 'Igbo',
  Yiddish: 'Yiddish',
  'Limburgan ; Limburger ; Limburgish': 'Limburgués; Limburgués; Limburgués',
  'Commandes validées': 'Pedidos validados',
  'listeRedacteur-': 'listRedactor-',
  Étape: 'Paso',
  'Energie/Environnement': 'Energía/Medio ambiente',
  Min: 'Min',
  Gujarati: 'Gujarati',
  'ne doit pas inclure votre nom/prénom': 'no debe incluir su nombre',
  'Typix - Fiche rédacteur': 'Typix - Archivo del redactor',
  'révisions effectuées en attentes de validation':
    'revisiones pendientes de validación',
  'Textes validés': 'Textos validados',
  Art: 'Arte',
  Dzongkha: 'Dzongkha',
  Polyvalent: 'Versátil',
  Sundanese: 'Sundanés',
  'Nb total de textes': 'Número total de textos',
  'Nombre de mots gérés': 'Número de palabras gestionadas',
  "L'émail": 'Esmalte',
  'Afficher les résultats': 'Resultados',
  'Frison occidental': 'Frisón occidental',
  'Modification effectuée avec succès': 'Modificación completada con éxito',
  'Balise titre': 'Etiqueta del título',
  'Typix - Mon profil': 'Typix - Mi perfil',
  'email invalide': 'correo no válido',
  'Veuillez ajouter une url afin de pouvoir sauvegarder le texte en brouillon':
    'Por favor, añada una url para poder guardar el texto como borrador',
  Macédonien: 'Macedonio',
  'Votre candidature a bien été envoyée': 'Su solicitud ha sido enviada',
  'E-mail': 'Correo electrónico',
  Fulah: 'Fulah',
  'Ajouter ou compléter ci-dessous votre contenu':
    'Añada o complete su contenido a continuación',
  Manx: 'Manx',
  'Ajout de mots-clés avec la fréquence restante':
    'Añadir palabras clave con la frecuencia restante',
  'Fiche du site web': 'Ficha del sitio web',
  Contacter: 'Póngase en contacto con',
  Fidjien: 'Fiyi',
  Déconnexion: 'Desconexión',
  email: 'correo electrónico',
  'Nombre de textes': 'Número de textos',
  'Enregistrer et informer client': 'Registrar e informar a los clientes',
  'Date de validation': 'Fecha de validación',
  'Tonga (Îles Tonga)': 'Tonga (Islas Tonga)',
  Javanais: 'javanés',
  Portugais: 'Portugués',
  Biélorusse: 'Bielorruso',
  'Pour ajouter un nouveau texte': 'Para añadir un nuevo texto',
  'Enfant/Puéri': 'Niño/Puperio',
  'Mots clés': 'Palabras clave',
  Emploi: 'Empleo',
  'Voulez-vous vraiment supprimer la commande de':
    '¿Realmente desea eliminar el',
  Consultants: 'Consultores',
  Volapük: 'Volapük',
  Services: 'Servicios',
  'mot-clé (fréquence)': 'palabra clave (frecuencia)',
  'Ne plus afficher ce message': 'No volver a mostrar este mensaje',
  Consultant: 'Consultor',
  "Une erreur s'est produite": 'Se ha producido un error',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un charactère spécial':
    'Al menos 8 caracteres con una letra mayúscula, un número, un carácter especial',
  'Pushto ; Pashto': 'Pushto; Pashto',
  Français: 'Francés',
  validées: 'validado',
  'Url du site': 'Url del sitio',
  Précédent: 'Anterior',
  'car celui-ci a déjà rédigé des textes':
    'porque este último ya ha redactado textos',
  'Kikuyu ; Gikuyu': 'Kikuyu; Gikuyu',
  Brouillons: 'Borradores',
  Ido: 'Ido',
  'Contenu disponible': 'Contenido disponible',
  Enseignement: 'Enseñanza',
  'a été livré avec succès': 'se ha entregado con éxito',
  Chinois: 'Chino',
  Vietnamien: 'Vietnamita',
  'Nouveau client': 'Nuevo cliente',
  'Votre profil a été mis à jour avec succès.':
    'Su perfil se ha actualizado correctamente.',
  Consignes: 'Instrucciones',
  'Mot de passe': 'Contraseña',
  Annuler: 'Cancelar',
  Non: 'No',
  Nom: 'Nombre',
  Guarani: 'Guaraní',
  "il y'a des commandes liés à au site web":
    'hay pedidos relacionados con el sitio web',
  Score: 'Puntuación',
  'Mot de passe mis à jour avec succès': 'Contraseña actualizada correctamente',
  Latin: 'Latín',
  Technologie: 'Tecnología',
  Internet: 'Internet',
  Nauru: 'Nauru',
  'a été créé avec succès': 'se ha creado correctamente',
  Roumain: 'Rumano',
  Assamais: 'Asamés',
  'Khmer central': 'Jemer central',
  'Navajo ; Navaho': 'Navajo; Navaho',
  'Panjabi ; Punjabi': 'Punjabi; Punjabi',
  'Analyse/Limite': 'Análisis/Límite',
  Grec: 'Griego',
  Ojibwa: 'Ojibwa',
  'Mes Projets': 'Mis proyectos',
  'keyword1 (2)\nkeyword2 (1)\nkeyword3 (1)\nkeyword4 (2)\n\u2026':
    'palabra clave1 (2)\npalabra clave2 (1)\npalabra clave3 (1)\npalabra clave4 (2)\n...',
  'ajouter un texte': 'añadir un texto',
  'Détail de la prestation': 'Detalles del servicio',
  "Vous avez la possibilité d'exporter le rapport d'une, ou de plusieurs commandes. Pour exporter toutes les commandes d'un client, il vous suffit juste de cliquer sur l'icône de téléchargement en jaune":
    'Tiene la posibilidad de exportar el informe de uno o varios pedidos. Para exportar todos los pedidos de un cliente, basta con hacer clic en el icono amarillo de descarga',
  'Gestion des utilisateurs': 'Gestión de usuarios',
  'livré et inférieur au nombre de texte non affecté':
    'entregados y menor que el número de textos no asignados',
  'Date deadline validation client': 'Plazo de validación del cliente',
  Aymara: 'Aymara',
  Validées: 'Validado',
  Notes: 'Notas',
  'Nombre de GMB': 'Número de GMB',
  'résultats sur': 'resultados en',
  'Prénom / Nom du client': 'Nombre / Apellido del cliente',
  'Tout télécharger': 'Descargar todo',
  'Champs obligatoires': 'Campos obligatorios',
  Éditer: 'Editar',
  'Coller le texte initial dans le champs ci-dessous':
    'Pegue el texto original en el campo siguiente',
  'ID rédacteur': 'ID de redactor',
  Arménien: 'Armenio',
  'Grande distribution': 'Distribución a gran escala',
  Welsh: 'Galés',
  Herero: 'Herero',
  'Enrichissement sémantique': 'Enriquecimiento semántico',
  'Détail de la prestation du contenu': 'Detalles de la entrega de contenidos',
  Noir: 'Negro',
  'Ajouter un texte': 'Añadir un texto',
  Traduction: 'Traducción',
  'Immo/Defisc': 'Propiedad/Fiscalidad',
  'Brief détaillé': 'Resumen detallado',
  'Séparez les mots-clés par un Enter .':
    'Separe las palabras clave con una Intro .',
  Prix: 'Premios',
  'mot de passe oublié': 'Contraseña olvidada',
  'Ndebele, South ; South Ndebele': 'Ndebele, Sur; Ndebele del Sur',
  'Demander une révision': 'Solicitar una revisión',
  'Demander une repasse globale': 'Solicitar una revisión integral',
  'Sotho, Southern': 'Sotho, Sur',
  'Le titre de la commande existe déjà': 'El título de la orden ya existe',
  'Félicitations !': '¡Felicidades!',
  Kurde: 'Kurdo',
  Adresse: 'Dirección',
  Espagnol: 'Español',
  Ndonga: 'Ndonga',
  'En retard': 'Tarde',
  'a été ajouté avec succès': 'se ha añadido correctamente',
  Commandes: 'Pedidos',
  'a été mis en brouillon': 'se ha redactado',
  'Rédacteur attribué': 'redactor asignado',
  Rechercher: 'Buscar en',
  'Nouvelle commande': 'Nuevo pedido',
  'Commandes non attribuées': 'Pedidos no asignados',
  'Le texte a été mis en brouillon': 'El texto ha sido redactado',
  'Contact edito': 'Contactar con edito',
  Langues: 'Idiomas',
  Orange: 'Naranja',
  'Nynorsk norvégien': 'Nynorsk noruego',
  Shona: 'Shona',
  Turkmène: 'Turkmen',
  'contenu repassé, en attente validation client':
    'contenido planchado, a la espera de la validación del cliente',
  'Nombre de mots rédigés': 'Número de palabras escritas',
  Malay: 'Malayo',
  'Nombre de Silo': 'Número de silos',
  Oui: 'Sí',
  Automobile: 'Automoción',
  Résultats: 'Resultados',
  Afar: 'Afar',
  'Tâche - id tâche': 'Tarea - id de tarea',
  'Ce champ est obligatoire doit être supérieur à 0':
    'Este campo es obligatorio y debe ser mayor que 0',
  'Vous êtes sûr': '¿Estás seguro de que',
  'Réinitialiser votre mot de passe': 'Restablecer contraseña',
  Sindhi: 'Sindhi',
  Bengali: 'Bengalí',
  'Bokmål, norvégien ; Bokmål norvégien': 'Bokmål, noruego; Bokmål noruego',
  'Nombre de Jours': 'Número de días',
  'Min/Max mots': 'Palabras mín./máx.',
  Slovène: 'Eslovenia',
  Site: 'Página web',
  'Sinhala ; Cingalais': 'Cingalés; Sinhalese',
  Bulgare: 'Búlgaro',
  'Liste des commandes': 'Lista de pedidos',
  "L'utilisateur": 'El usuario',
  Uzbek: 'Uzbeko',
  'Titre du texte': 'Título del texto',
  Postuler: 'Solicitar en',
  'Nb de textes par Silo': 'Nº de textos por silo',
  'Nombre total de mots (existants et ajoutés)':
    'Número total de palabras (existentes y añadidas)',
  'Max.': 'Max.',
  Beauté: 'Belleza',
  Humanitaire: 'Humanitario',
  Telugu: 'Telugu',
  'Recherche par rédacteur ou texte': 'Búsqueda por autor o texto',
  'Balise meta-description': 'Etiqueta meta descripción',
  Malgache: 'Malgache',
  Tagalog: 'Tagalo',
  'Ce champs doit être sup à 0 et inférieur à 1':
    'Este campo debe ser mayor que 0 y menor que 1',
  'Le rédacteur': 'El redactor',
  'a été mis à jour avec succès': 'se ha actualizado correctamente',
  'Avoir au moins 8 caractères avec une lettre majuscule, un chiffre, un symbole et ne pas être identique au nom.':
    'Debe tener al menos 8 caracteres con una letra mayúscula, un número, un símbolo y no ser idéntico al nombre.',
  'textes en plus': 'más textos',
  'Format souhaité': 'Formato deseado',
  Chamorro: 'Chamorro',
  Malayalam: 'Malayalam',
  'Détail ligne de commande': 'Detalle de la línea de pedido',
  'Veuillez préciser la date': 'Especifique la fecha',
  Pali: 'Pali',
  Clients: 'Clientes',
  'Total facturé': 'Total facturado',
  'contenu validé par le client': 'contenido validado por el cliente',
  'Occitan (post 1500)': 'Occitano (después de 1500)',
  Japonais: 'Japonés',
  Avaric: 'Avaric',
  'Voulez-vous vraiment activer': '¿De verdad quieres activar',
  Sanskrit: 'Sánscrito',
  'Toutes les notifications': 'Todas las notificaciones',
  Marathi: 'Marathi',
  Persan: 'Persa',
  'La commande pour le client': 'El pedido del cliente',
  'Intitulé de la commande': 'Título de la orden',
  Samoan: 'Samoa',
  Autres: 'Otros',
  Sport: 'Deporte',
  "il y'a des commandes liés au site web ":
    'hay pedidos relacionados con el sitio web',
  'Ajout de mots-clé avec la fréquence restante':
    'Añadir palabras clave con la frecuencia restante',
  'a été supprimé avec succès': 'ha sido eliminado con éxito',
  Postulé: 'Publicado en',
  Literie: 'Ropa de cama',
  'Édité par le client': 'Editado por el cliente',
  Cornouailles: 'Cornualles',
  Tigrinya: 'Tigriña',
  Textes: 'Textos',
  'Soumettre un nouveau texte': 'Enviar un nuevo texto',
  Téléphone: 'Teléfono',
  Deadline: 'Plazo',
  "Une erreur s'est produite. Veuillez vérifier votre saisie ou essayer plus tard.":
    'Se ha producido un error. Por favor, compruebe su entrada o inténtelo más tarde.',
  Marshallais: 'Marshall',
  "La demande d'ajout de crédit est envoyée":
    'Se envía la solicitud para añadir crédito',
  'Le rédacteur ': 'El redactor',
  'Demander des crédits': 'Solicitar un crédito',
  "Cette commande n'existe pas": 'Este comando no existe',
  Inupiaq: 'Inupiaq',
  Tahitien: 'Tahití',
  Admins: 'Admins',
  'Mettez des mots-clés avec fréquence':
    'Establecer palabras clave con frecuencia',
  Notifications: 'Notificaciones',
  'en retard': 'tarde',
  "l'admin": 'el administrador',
  'Mail rédacteurs': 'redactores de correo',
  Amharique: 'Amárico',
  Societe: 'Empresa',
  Tsonga: 'Tsonga',
  'Nombre de textes ajoutés': 'Número de textos añadidos',
  "Nombre d'agents": 'Número de agentes',
  Société: 'Empresa',
  Yoruba: 'Yoruba',
  'Le texte a été livré avec succès': 'El texto se ha entregado correctamente',
  'Mettez votre texte': 'Pon tu texto',
  "Oups....! Une erreur s'est produite": '¡Oops....! Se ha producido un error',
  'Prénom/Nom': 'Nombre y apellidos',
  'Max doit être sup à Min': 'Max debe ser mayor que Min',
  'Importer un autre document': 'Importar otro documento',
  'Votre demande a expirée .. veuillez refaire une autre':
    'Su solicitud ha caducado ... por favor haga otra',
  'Veuillez corriger le format de votre gap sémantique afin de pouvoir sauvegarder le texte en brouillon':
    'Por favor, corrija el formato de su brecha semántica para guardar el texto como borrador',
  Exemple: 'Ejemplo',
  Slovaque: 'Eslovaquia',
  Finance: 'Finanzas',
  Réactiver: 'Reactivar',
  'Nb textes': 'Nº de textos',
  'Intitulé commande': 'Título del pedido',
  Supprimer: 'Borrar',
  Brouillon: 'Borrador',
  'Mots clés restants': 'Palabras clave restantes',
  Date: 'Fecha',
  Rôle: 'Papel',
  'Ce champs doit être sup à 0': 'Este campo debe ser mayor que 0',
  'Maison/Déco': 'Hogar/Decoración',
  'Vous avez': 'Usted tiene',
  'Cette ligne de commande ne peut pas être supprimée car une partie de ses textes a été livré':
    'Esta línea de comandos no puede borrarse porque parte de su texto ha sido entregado',
  'vérifiez votre email et cliquez sur le lien pour continuer !':
    'compruebe su correo electrónico y haga clic en el enlace para continuar.',
  Sarde: 'Cerdeña',
  'Note rédacteur': 'Nota del redactor',
  'Uighur ; Uyghur': 'Uigur; uigur',
  Name: 'Nombre',
  'Commandes intelligentes': 'pedidos smart',
  'Commandes avec révision': 'pedidos smart + review',
  'Type de contenu': 'Tipo de contenido',
  'Fiche produit': 'Ficha de producto',
  GMB: 'GMB',
  'STORE LOCATOR': 'STORE LOCATOR',
  'Rédaction premium': 'Escritura premium',
  'Rédaction avec révision': 'Escritura smart + review',
  'Rédaction intelligente': 'Escritura smart',
  PREMIUM: 'PREMIUM',
  Type: 'Tipo',
  Editer: 'Editar',
  'Tous les types': 'Todos los tipos',
  Smart: 'Smart',
  'Smart + review': 'Smart + review',
  'Factures traitées': 'Facturas procesadas',
  'Factures à valider': 'Facturas por validar',
  'Impossible de générer la facture ! Veuillez réessayer':
    'Imposible generar la factura. Por favor, inténtelo de nuevo',
  'Récapitulatif de facturation': 'Resumen de facturación',
  'Demander une modification': 'Solicitar una modificación',
  'Valider et envoyer la facture': 'Validar y enviar la factura',
  'Demande de modification': 'Solicitud de modificación',
  'La facture a été validé avec succès!':
    '¡La factura se ha validado correctamente!',
  "Oups un erreur c'est produit!": '¡Ups! Se ha producido un error',
  'Nombre de texte': 'Número de textos',
  'Nombre de mot par texte :': 'Número de palabras por texto:',
  Paiement: 'Pago',
  Virement: 'Transferencia bancaria',
  Délai: 'Plazo',
  'Référence de votre facture': 'Referencia de su factura',
  'Coût au mot': 'Costo por palabra',
  'Montant global de la commande': 'Monto total del pedido',
  'Votre facture': 'Su factura',
  'Importer votre facture': 'Importar su factura',
  'Pas de fichier disponible': 'No hay archivo disponible',
  Télécharger: 'Descargar',
  Relancer: 'Reenviar',
  'Générer la facture': 'Generar la factura',
  Payée: 'Pagada',
  'En cours de paiement': 'En proceso de pago',
  'En cours de validation': 'En proceso de validación',
  'A envoyer': 'Por enviar',
  'Modification demandée': 'Modificación solicitada',
  'Référence de facture est obligatoire': 'Se requiere referencia de factura',
  'Le coût au mot doit être un nombre':
    'El costo por palabra debe ser un número',
  'Le coût au mot doit être un nombre positif':
    'El costo por palabra debe ser un número positivo',
  'Le coût au mot est obligatoire': 'Se requiere el costo por palabra',
  'Le montant global de la commande doit être un nombre':
    'El monto total del pedido debe ser un número',
  'Le montant global de la commande doit être un nombre positif':
    'El monto total del pedido debe ser un número positivo',
  'Le montant global de la commande est obligatoire':
    'Se requiere el monto total del pedido',
  'Bill reference existe déja , veuillez réessayer':
    'La referencia de la factura ya existe, por favor, inténtelo de nuevo',
  'La facture a été envoyée avec succès!':
    '¡La factura se ha enviado correctamente!',

  'Montant estimé': 'Monto estimado',
  Action: 'Acción',
  Facture: 'Factura',
  Statut: 'Estado',
  Factures: 'Facturas',
  'Valider la facture': 'Validar la factura',
  'La relance a été envoyée avec succès !':
    '¡El recordatorio se ha enviado con éxito!',
  'La demande de modification a été envoyée avec succès !':
    '¡La solicitud de modificación se ha enviado con éxito!',
  'Le cout est trop élevé': 'El costo es demasiado alto',
  'Le montant global de la commande est trop élevé ':
    'El monto total del pedido es demasiado alto',
  jours: 'días',
  'Factures à envoyer': 'Facturas a enviar',
  'Valider le paiement': 'Validar pago',
  'Générer une facture': 'Generar una factura',
  'Montant rédacteur': 'Monto del redactor',
  'Montant estimé par Typix': 'Monto estimado por Typix',
  'Voir la modification': 'Ver modificación',

  'Tag de Titre': 'Etiqueta del título',
  'Meta description': 'Meta descripción',
  'Nom du produit': 'Nombre del producto',
  Avantages: 'Ventajas',
  'Description détaillée': 'Descripción detallada',
  'En cours de modification': 'En proceso de modificación',
  'Mes Factures': 'Mis facturas',
  'En attente de validation': 'En espera de validación',
  'les valeurs négatives ne sont pas autorisées':
    'No se permiten valores negativos.',
  'Texte Seulement': 'Solo texto',
  'Traduction Seulement': 'Solo traducción',
  'La relance peut être faite 20 jours après la soumissions de la facture':
    'El recordatorio se puede enviar 20 días después del envío de la factura',
  Instructions: 'Instrucciones',
  'Votre avis pour la commande': 'Tu opinión sobre el pedido',
  'Votre évaluation est précieuse pour nous ! Merci !':
    '¡Tu evaluación es valiosa para nosotros! ¡Gracias!',
  "Une erreur s'est produite lors de la soumission de votre évaluation. Veuillez réessayer ultérieurement!":
    'Se produjo un error al enviar tu evaluación. Por favor, inténtalo de nuevo más tarde.',
  Evaluer: 'Evaluar',
  Commentaire: 'Comentario',
  'Votre commantaire': 'Tu comentario',
  Note: 'Calificación',
  'Votre retour est précieux pour nous et nous aide à améliorer nos services.':
    'Tu feedback es valioso para nosotros y nos ayuda a mejorar nuestros servicios.',
  'Verifier la facture': 'Verificar la factura',

  ' Votre retour est précieux pour nous et nous aide à améliorer nos services. Merci de partager votre évaluation avec nous!':
    'Su opinión es valiosa para nosotros y nos ayuda a mejorar nuestros servicios. ¡Gracias por compartir su evaluación con nosotros!',
  'Notes rédacteur': 'Notas del redactor',
  'Avis client': 'Opiniones de clientes',
  'Pas de commantaire': 'Sin comentario',
  "Qu'avez vous pensé de votre commande?": '¿Qué opinas de tu pedido?',
  'Evaluation de la commande': 'Evaluación del pedido',
  'Rédiger un commentaire': 'Redactar un comentario',
  'Contribuez à nous permettre de vous proposer les services de rédaction de la plus haute qualité en partageant vos commentaires.':
    'Contribuye a permitirnos ofrecerte servicios de redacción de la más alta calidad compartiendo tus comentarios.',
  'Que pouvons-nous améliorer?': '¿Qué podemos mejorar?',
  Continuer: 'Continuar',
  'Le dernier texte a été validé avec succès':
    'El último texto ha sido validado con éxito',
  'Rechercher par rédacteur, commandes, et montant':
    'Buscar por redactor, pedidos y monto',
  obligatoire: 'obligatorio',
  'Note admin': 'Nota del administrador',
  'Note client': 'Nota del cliente',
  Partie: 'Parte',
  'Vous venez de valider tous les contenus rédigés par ':
    'Acabas de validar todo el contenido escrito por ',
  "Qu'en avez vous pensé": '¿Qué opinas al respecto',
  'La facture a été générée avec succès !':
    '¡La factura se ha generado con éxito!',
  'La taille du titre et/ou la méta-description est trop courte':
    'La longitud del título y/o la meta descripción es demasiado corta',

  'Demande de révision globale': 'Requiere una revisión global',
  Valider: 'Validar',
  'Obligatoire en cas d’optimisation ou traduction':
    'Obligatorio en caso de optimización o traducción',
  'Mots clés Bourrées': 'Keyword stuffing',
  'Votre commentaire...': 'Tu comentario...',
  'Ex : "Contenus de très bonne qualité':
    'Ej.: "Contenido de muy buena calidad"',
  "pouvez-vous s'il vous plaît reprendre ce/tte rédacteur/rice pour les prochaines commandes?":
    '¿Podría considerar asignar a este/a redactor/a para futuros pedidos, por favor?',
  'Ce bouton est pour informer le client que le texte initial, contenait déjà du keyword stuffing':
    'Este botón es para informar al cliente que el texto original ya contenía relleno de palabras clave',
  'Maillage Interne': 'Internal link',
  'Modifier le texte': 'Editar el texto',
  Ajouter: 'Agregar',
  'Demande examen': 'Solicitud de examen',
  'Recherche de mots clés à haute densité': 'Investigación de keyword stuffing',
  'Oups, il semblerait qu’il y ait du keyword stuffing dans votre texte : ':
    '¡Ups, parece que hay keyword stuffing en tu texto: ',
  'Oups, il semblerait qu’il y ait du keyword stuffing (trop d’occurrences d’un ou plusieurs mots clés) dans le texte initial.':
    '¡Ups, parece que hay keyword stuffing (demasiadas ocurrencias de una o más palabras clave) en el texto original.',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).':
    'Por favor, asegúrese de que la densidad de palabras clave esté optimizada para SEO (un máximo de una ocurrencia cada 50 palabras).',
  'Pour cela merci de ne pas retoucher le texte existant et de bien vouloir envoyer une demande d’examen au support.':
    'Para ello, por favor no edite el texto existente y envíe amablemente una solicitud de examen al soporte.',
  'Votre demande a été bien envoyée !':
    '¡Su solicitud ha sido enviada con éxito!',
  "Il y a eu un problème lors de l'envoi de votre demande":
    'Hubo un problema al enviar su solicitud.',
  'Veuillez attendez pour le  keyword Stuffing analyse':
    'Por favor, espere el análisis de keyword stuffing.',
  'Inserez le maillage interne': 'Vložte vnútornú sieť',
  'Merci de vous assurer que la densité des mots clés soit optimisée pour le SEO (une occurrence maximum tous les 50 mots).\nSi vous constatez un terme pouvant avoir plusieurs significations (Exemple : Former / Formation/ Forme ou Matelas/Matelassé) , vous pouvez faire une demande d’examen auprès du support.':
    'Gracias por asegurarse de que la densidad de palabras clave esté optimizada para el SEO (una ocurrencia máxima cada 50 palabras).\nSi nota un término que puede tener múltiples significados (Ejemplo: Formar / Formación / Forma o Colchón / Acolchado), puede solicitar una revisión al soporte.',
  'Mots clés à haute densité dans le texte actuel':
    'Palabras clave de alta densidad en el texto actual',
  'Mots clés à haute densidad dans le texte initial':
    'Palabras clave de alta densidad en el texto inicial',
  'Texte en cours de rédaction !': 'Texto en proceso de redacción !',
  'Êtes-vous sûr(e) de vouloir valider le texte ? Assurez-vous d’abord d’avoir enregistré les modifications.':
    '¿Estás seguro/a de querer confirmar el texto? Asegúrate primero de haber guardado los cambios.',
  "Information dernière minute ! Ton stock de crédits sera bientôt épuisé :( Pour anticiper, n'hésite pas à demander dès maintenant plus de crédits pour terminer ta commande.":
    '¡Información de última hora! Tu saldo de créditos se agotará pronto :( Para anticiparte, no dudes en solicitar más créditos ahora para completar tu pedido.',
  'Voulez-vous confirmer l’URL actuelle ou la modifier ?':
    '¿Quiere confirmar la URL actual o modificarla?',
  'Veuillez fournir une URL valide': 'Por favor, proporcione una URL válida.',
  'Merci de bien vouloir indiquer ci-dessous l’url de la page où a été intégré le contenu:':
    'Por favor, indique a continuación la URL de la página donde se ha integrado el contenido:',
  'Contenu en ligne': 'Contenido en línea',
  'Télécharger le document de révision': 'Descargar el documento de revisión',
  'Date d’envoi': 'Fecha de envío',
  Information: 'Información',
  Enregistrer: 'Guardar',
  'Textes en ligne': 'Textos en línea',
  'Livrer les textes': 'Entregar los textos',
  Indisponible: 'No disponible',
  Disponible: 'Disponible',
  'Les textes ont été livrés avec succès.':
    'Los textos han sido entregados con éxito.',
  'Le texte a été livré avec succès.': 'El texto ha sido entregado con éxito.',
  'Les textes ont été validés avec succès.':
    'Los textos han sido validados con éxito.',
  'Le texte a été validé avec succès.': 'El texto ha sido validado con éxito.',
  'Voulez-vous vraiment valider les Textes de la commande':
    '¿Realmente quieres validar los textos del pedido?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    '¿Realmente quieres entregar los textos del pedido?',
  'Voulez-vous vraiment livrer les Textes de la commande':
    'Vill du verkligen leverera beställningens texter?',
  'Fiche produit longue': 'Ficha de producto larga',
  'Fiche produit courte': 'Ficha de producto corta',
  'Un texte est trop long et ne peut pas être exporté sur Excel':
    'Un texto es demasiado largo y no se puede exportar a Excel.',
  'Mettre un texte en brouillon en livré':
    'Cambiar un texto de borrador a entregado',
  'Remettre un texte validé à livré': 'Cambiar un texto validado a entregado',
  'Invalider le texte': 'Invalidar el texto',
  'Je souhaiterai modifier mon mot de passe : comment faire ?':
    'Quisiera cambiar mi contraseña: ¿cómo lo hago?',
  'Comment mettre un contenu en bon pour livraison ?':
    '¿Cómo poner el contenido listo para entrega?',
  'Je ne peux pas mettre mon contenu en « brouillon »':
    '¿No puedo guardar mi contenido como "borrador"',
  'Typix n’a pas enregistré mes dernières modifications':
    'Typix no guardó mis últimos cambios',
  'Comment rédiger une création de contenu ?':
    '¿Cómo redactar una creación de contenido?',
  'Comment rédiger une optimisation de contenu ?':
    '¿Cómo redactar una optimización de contenido?',
  'Je ne vois plus ma commande – que faire ?':
    '¿Ya no veo mi pedido – qué hacer?',
  'Comment générer une facture ?': '¿Cómo generar una factura?',
  'Je ne peux pas generer ma facture : que faire ?':
    'No puedo generar mi factura: ¿qué hacer?',
  'Tuto process Typix global': 'Proceso global Typix - tutorial',
  'Tuto mise en ligne des contenus': 'Cómo subir contenido - tutorial',
  'Modification mot de passe': 'Cambio de contraseña',
  'Le test ne me convient pas': 'La prueba no me conviene',
  'Comment valider un contenu dans Typix ?':
    '¿Cómo validar contenido en Typix?',
  'Tuto Facturation': 'Tutorial de facturación',
  'Le statut du contenu a bien été modifié':
    'El estado del contenido ha sido modificado con éxito',
  'Le statut du contenu a bien été modifié':
    'El estado del contenido ha sido modificado con éxito',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'La brecha semántica de esta palabra clave aún no ha sido validada, póngase en contacto con el soporte de Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Esta palabra clave no existe en MONETORING, verifique con el soporte de Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperar el hueco',
  'Le statut du contenu a bien été modifié':
    'El estado del contenido ha sido modificado con éxito',
  'Le statut du contenu a bien été modifié':
    'El estado del contenido ha sido modificado con éxito',
  'Le gap sémantique de ce mot clé n’a pas encore été validé, veuillez contacter le support Typix : support-typix@pixalione.com':
    'La brecha semántica de esta palabra clave aún no ha sido validada, póngase en contacto con el soporte de Typix: support-typix@pixalione.com',
  'Ce mot clé n’existe pas sur MONETORING, veuillez vérifier avec le support Typix : support-typix@pixalione.com':
    'Esta palabra clave no existe en MONETORING, verifique con el soporte de Typix: support-typix@pixalione.com',
  'Récupérer le Gap': 'Recuperar el hueco',
  'Traduction premium': 'Traducción premium',
  'Rédaction et/ou Traduction intelligente':
    'Redacción y/o Traducción inteligente',
  'Rédaction et/ou Traduction premium': 'Redacción y/o Traducción premium',
  'Rédaction et/ou Traduction avec révision':
    'Redacción y/o Traducción con revisión',
  'Rédaction et/ou Traduction premium': 'Redacción y/o Traducción premium',
  'Rédaction et/ou Traduction avec révision':
    'Redacción y/o Traducción con revisión',
  'Rédaction et/ou Traduction intelligente':
    'Redacción y/o Traducción inteligente',
  'Traduction avec révision': 'Traducción con revisión',
  'Traduction intelligente': 'Traducción inteligente',
  'Le nombre de mots commandé est supérieur à celui vendu':
    'El número de palabras pedidas es mayor que las vendidas',
  'Rédaction et/ou Traduction premium': 'Redacción y/o traducción premium',
  'Rédaction et/ou Traduction smart + review':
    'Redacción y/o traducción inteligente + revisión',
  'Rédaction et/ou Traduction smart': 'Redacción y/o traducción inteligente',
  'Nom Silo': 'Nombre Silo',
  'Remettre en brouillon': 'Volver a borrador',
  'Bon pour Livraison Vérifié': 'Verificado para entrega',
  'Voulez-vous vraiment remettre en brouillon les Textes de la commande':
    '¿Está seguro de que desea volver a borrador los textos del pedido',
  'La vérification du texte a été annulée.':
    'La verificación del texto ha sido cancelada.',
  'Voulez-vous vraiment annuler la vérification du texte?':
    '¿Está seguro de que desea cancelar la verificación del texto?',
  'Etes-vous sûr(e) de vouloir regénérer tous les contenus ?':
    '¿Está seguro(a) de que desea regenerar todo el contenido?',
  'Je suis sûr(e)': 'Estoy seguro/a',
  'Non, revenir en arrière': 'No, volver atrás',
  'à cocher si la commande a l’intention d’avoir un rédacteur exclusif pour le client':
    'marcar si el pedido tiene la intención de tener un redactor exclusivo para el cliente',
  Gouvernance: 'Gobernanza',
  'Modification à valider': 'Modificación para validar',
  Rédacteur: 'Redactor',
  'Nouveau site web': 'Nuevo sitio web',
  'Mail Chef Project': 'Correo del jefe de proyecto',
  'Site web': 'Sitio web',
  'Liste des siteweb': 'Lista de sitios web',
  'Projets non attribuées': 'Proyectos no asignados',
  'Projets en cours': 'Proyectos en curso',
  'Projets en retard': 'Proyectos retrasados',
  'Projets validées': 'Proyectos validados',
  'Projets smart + reviews': 'Proyectos smart + reviews',
  'Projets smart': 'Proyectos smart',
  'Ajouter un siteweb': 'Agregar un sitio web',
  'Nouveau projet': 'Nuevo proyecto',
  //////////////////////////
  'Comparaison du score global': 'Comparison of global score',
  'avec le top 3 concurrents': 'with top 3 competitors',
  'Position du mot clé avec le top 3 concurrents': 'Keyword ranking',
  //////

  Balises: 'Etiquetas',
  Lisibilité: 'Legibilidad',
  'Longueur des paragraphes': 'Longitud de los párrafos',
  Phrases: 'Frases',
  'de +100 mots sur': 'de más de +100 palabras en',
  Phrase: 'Frase',
  'de +20 mots sur': 'de más de +20 palabras en',
  'Notre recommandation': 'Nuestra recomendación',
  'Longueur du texte': 'Longitud del texto',
  'Formats de contenus variés': 'Formatos de contenido variados',
  'par rapport au top 3 de vos concurrents':
    'en comparación con el top 3 de tus competidores',
  'Vous êtes': 'Tú eres',
  'Vous avez un score global de': 'Tienes una puntuación global de',
  'pour une moyenne du secteur à': 'para una media del sector de',
  'GAP comblé - Mission accomplie': 'Brecha cerrada – Misión cumplida',
  'Mots clé restants': 'Palabras clave restantes',
  'Phrases de +20 mots': 'Frases de más de 20 palabras',
  'Titre H1': 'Título H1',
  'Titres H2': 'Títulos H2',
  'Dans le texte actuel': 'En el texto actual',
  'Dans le texte initial': 'En el texto inicial',
  mots: 'palabras',
  objectif: 'objetivo',
  phrase: 'frase',
  paragraphe: 'párrafo',
  'Temps de lecture': 'Tiempo de lectura',
  'requis ( Bullet point, Bon à savoir,Sommaire)':
    'requerido (viñetas, bueno saberlo, resumen)',
  'de contenu sur': 'cantidad de contenido en',
  'Félicitations ! Le nombre de mots correspond à la quantité d’informations importantes permettant de répondre au sujet':
    '¡Felicidades! El número de palabras corresponde a la cantidad de información necesaria para responder al tema.',
  'Félicitations ! Votre contenu ne contient aucune phrase de plus de 20 mots !':
    '¡Felicidades! Tu contenido no contiene ninguna frase de más de 20 palabras.',
  'Félicitations ! Votre contenu est aéré et facilite la lecture':
    '¡Felicidades! Tu contenido está bien aireado y facilita la lectura.',
  'Félicitations ! Votre contenu dispose de formats variés qui dynamisent la lecture et permettent d’isoler les informations importantes.':
    '¡Felicidades! Tu contenido utiliza formatos variados que dinamizan la lectura y resaltan la información importante.',
  'Félicitations ! Le contenu présente une balise h1 unique et contient le mot clé à l’origine du texte':
    '¡Felicidades! El contenido tiene una única etiqueta H1 e incluye la palabra clave principal.',
  'Félicitations ! Le contenu est structuré de façon cohérente et présente au moins 2 balises <h2>':
    '¡Felicidades! El contenido está estructurado de manera coherente y presenta al menos dos etiquetas <h2>.',
  'Félicitations ! Votre contenu contient du maillage interne pondéré et qui ne pollue pas la lecture.':
    '¡Felicidades! Tu contenido contiene enlaces internos equilibrados que no afectan la lectura.',
  'Félicitations ! Le scoring d’enrichissement est supérieur à 85%!':
    '¡Felicidades! La puntuación de enriquecimiento supera el 85 %.',
  'Félicitations ! Votre texte n’est pas suroptimisé sur le mot clé ciblé.':
    '¡Felicidades! Tu texto no está sobreoptimizado para la palabra clave.',
  'Le nombre de mots doit correspondre à la quantité d’informations importantes permettant de répondre au sujet':
    'El número de palabras debe corresponder a la cantidad de información necesaria para responder al tema.',
  'Il est important d’adapter le niveau de vocabulaire en fonction de votre cible. Un vocabulaire simple pourrait l’infantiliser et, à l’inverse, un vocabulaire trop complexe pourrait rendre le contenu inaccessible.':
    'Es importante adaptar el nivel de vocabulario según tu público. Un vocabulario demasiado simple puede infantilizar, mientras que uno demasiado complejo puede dificultar la comprensión.',
  'Plus de 70% des internautes ne lisent pas les phrases > 20 mots => Utiliser des phrases concises pour augmenter le temps de rétention sur la page':
    'Más del 70% de los usuarios no leen frases de más de 20 palabras → Usa frases concisas para aumentar el tiempo de permanencia en la página.',
  "Un contenu constitué de blocs de paragraphes trop compact va altérer l'UX et augmenter le taux de rebond.":
    'Un contenido con párrafos demasiado compactos afecta la experiencia de usuario y aumenta la tasa de rebote.',
  "Multipliez les différents formats d'affichage pour une lecture plus lisible et confortable.":
    'Varía los formatos de presentación para una lectura más clara y cómoda.',
  'Un contenu optimisé doit obligatoirement contenir une seule balise h1 et mentionner le mot clé. ':
    'Un contenido optimizado debe contener una única etiqueta H1 y mencionar la palabra clave.',
  'Pour une structure de contenu optimale, il faut au moins 2 balises h2.':
    'Para una estructura óptima, se necesitan al menos 2 etiquetas H2.',
  'Le maillage interne est un très bon moyen de connecter une page avec d’autres pages traitant du même sujet, ou complémentaires.':
    'El enlazado interno es una excelente manera de conectar una página con otras relacionadas o complementarias.',
  'Un contenu optimisé doit obtenir un scoring d’enrichissement de min 85%. Supprimer du gap sémantique altèrera le scoring d’optimisation':
    'Un contenido optimizado debe alcanzar un 85% mínimo de puntuación de enriquecimiento. Eliminar contenido semántico reduce esta puntuación.',
  'Répéter le mot trop de fois dans le contenu est pénalisant pour le moteur de recherche. Idéalement, ne pas dépasser un taux de 2.35% (soit environs 2 répétitions pour 100 mots). ':
    'Repetir la palabra clave demasiadas veces penaliza en los motores de búsqueda. Idealmente, no superar un 2,35% (unas 2 repeticiones por cada 100 palabras).',
  'Aucune balise H1 trouvée.': 'No se encontró ninguna etiqueta H1.',
  'Balise H1 contient le mot-clé.': 'La etiqueta H1 contiene la palabra clave.',
  'Balise H1 présente mais sans le mot-clé.':
    'La etiqueta H1 está presente pero no contiene la palabra clave.',
  '{{count_total}} balises H2 trouvées, {{count_with_kw}} avec mot-clé.':
    '{{count_total}} etiquetas H2 encontradas, {{count_with_kw}} con palabra clave.',
  ' balises H2 trouvées,': ' etiquetas H2 encontradas,',
  ' avec mot-clé.': ' con palabra clave.',
  'Très facile à lire : Accessible aux enfants ou à des personnes avec un niveau de lecture basique.':
    'Muy fácil de leer: accesible para niños o personas con lectura básica.',
  'Facile à lire : Compréhensible par la majorité des adultes et adolescents.':
    'Fácil de leer: comprensible para la mayoría de adultos y adolescentes.',
  'Difficile à lire : Nécessite un bon niveau de lecture, parfois un bagage académique':
    'Difícil de leer: requiere buen nivel de lectura, a veces formación académica.',
  'Très difficile à lire : Réservé à un public expert ou très averti':
    'Muy difícil de leer: reservado para lectores expertos o muy avanzados.',
  'Wording adapté': 'Redacción adaptada',
  "La balise H1 est essentielle pour l'optimisation SEO.":
    'La etiqueta H1 es esencial para la optimización SEO.',
  'Une seule balise H1 avec le mot-clé est recommandée.':
    'Se recomienda una sola etiqueta H1 con la palabra clave.',
  'Ajoutez le mot-clé dans la balise H1.':
    'Añade la palabra clave en la etiqueta H1.',
  'Adaptez votre vocabulaire à votre audience. Trop simple infantilise, trop complexe exclut.':
    'Adapta tu vocabulario a tu audiencia. Demasiado simple infantiliza, demasiado complejo excluye.',
  'Les contenus web se lisent rapidement. Un temps trop long peut décourager.':
    'El contenido web se lee rápidamente. Un tiempo demasiado largo puede desanimar.',
  'Information sur la structure': 'Información sobre la estructura',
  'Information sur le résultat sémantique': 'Información sobre el resultado semántico',
  'Information sur les balises HTML': 'Información sobre las etiquetas HTML',
  'Information sur le keyword stuffing': 'Información sobre el keyword stuffing',

  ////////////////////////////////



  'Derniers contenus rédigés': 'Últimos contenidos redactados',
  'voir plus': 'Ver más',
  'texte': 'Texto',
  'date d\'ajout': 'Fecha de adición',
  'titre du projet': 'Título del proyecto',
  'Date de création': 'Fecha de creación',
  'dernières projets créés': 'Últimos proyectos creados',
  '% projets par statut de validation :': '% de proyectos por estado de validación:',
  'non attribués': 'No asignados',
  'en cours': 'En curso',
  'en retard': 'Retrasados',
  'validées': 'Validados',
  'smart + reviews': 'Smart + revisión',
  'smart': 'Smart',
  'premium': 'Premium',
  'smart + review': 'Smart + revisión',
  'Statut d\'avancement des contenus:': 'Estado de progreso del contenido:',
  'Nombre de textes publiés :': 'Número de textos publicados:',
  'Nb de textes publiés': 'Nº de textos publicados',
  'Top ranked': 'Mejor clasificados',
  'Mot clé': 'Palabra clave',
  'Clicks': 'Clics',
  'Clicks (Y-1)': 'Clics (A-1)',
  'Position': 'Posición',
  'Sessions': 'Sesiones',
  'Sessions (Y-1)': 'Sesiones (A-1)',
  'Evolution performance': 'Evolución del rendimiento',
  'Pourcentage': 'Porcentaje',
  'Livré': 'Entregado',
  'Publié': 'Publicado',
  'Suivez vos contenus et projets en temps réel': 'Sigue tus contenidos y proyectos en tiempo real',
  'Tableau de bord': 'Panel de control',
  'Titre du projet': 'Título del proyecto',
  'Conversions': 'Conversiones',
  'Impressions': 'Impresiones',
  'Jan': 'Ene',
  'Fév': 'Feb',
  'Mars': 'Mar',
  'Avr': 'Abr',
  'Mai': 'May',
  'Juin': 'Jun',
  'Juil.': 'Jul',
  'Août': 'Ago',
  'Sept': 'Sep',
  'Oct': 'Oct',
  'Nov': 'Nov',
  'Déc': 'Dic',
  'Pour activer cette fonctionnalité, ajoutez notre adresse ': 'Para activar esta función, añade nuestra dirección ',
  ' à votre ': ' a tu ',
  'Search Console': 'Search Console',
  ', ': ', ',
  'puis cliquez ici pour lancer l’analyse.': 'luego haz clic aquí para iniciar el análisis.',
  'all devices': 'todos los dispositivos',
  'Desktop': 'Escritorio',
  'Mobile': 'Móvil',
  '30 days': '30 días',
  '7 days': '7 días',
  '90 days': '90 días',
  'Aucun projet créé pour le moment.': 'Ningún proyecto creado por el momento.',
  'Lancer votre premier projet': 'Inicia tu primer proyecto',
  'Aucun contenu disponible pour ce site web.': 'No hay contenido disponible para este sitio web.',
  'Mes contenus': 'Mis contenidos',
  'Type de contenu': 'Tipo de contenido',
  'Date d\'ajout': 'Fecha de adición',
  'URL': 'URL',
  'Status': 'Estado',
  'Date de livraison': 'Fecha de entrega',
  'Date de validation': 'Fecha de validación',
  'Date de déploiement': 'Fecha de publicación',
  'Action': 'Acción',
  'Aucun contenu pour ce filtre.': 'No hay contenido para este filtro.',
  'Chargement...': 'Cargando...',
  'Aucun contenu.': 'Sin contenido.',
  'Précédent': 'Anterior',
  'Suivant': 'Siguiente',
  'fiche produit': 'Ficha de producto',
  'Page catégorie': 'Página de categoría',
  'Fiche GMB': 'Ficha GMB',
  'store locator': 'Localizador de tiendas',
  'redaction': 'Redacción',
  'traduction': 'Traducción',
  'Fiches produit SEO': 'Fichas de producto SEO',
  'Derniers projets crées': 'Últimos proyectos creados',
  'Agent IA': 'Agente IA',
  'Dérniére mise à jour': 'Última actualización',
  'Créer un nouveau contenu': 'Crear nuevo contenido',
  'Rédigez un texte optimisé grâce à l’IA — rapide, pertinent et performant.': 'Redacta un texto optimizado con IA — rápido, relevante y eficaz.',
  'Validé': 'Validado',
  'En ligne': 'En línea',
  'Fiches GMB': 'Fichas GMB',
  'Fiches store locator': 'Fichas de localizador de tiendas',
  'Pages catégories': 'Páginas de categoría',
  'Traduction IA': 'Traducción IA',
  'Actions': 'Acciones',
  'Traduire un nouveau contenu': 'Traducir nuevo contenido',
  'Traduisez vos contenus automatiquement avec une précision multilingue.': 'Traduce tus contenidos automáticamente con precisión multilingüe.',
  'Nom du projet': 'Nombre del proyecto',
  'Chef de projet': 'Jefe de proyecto',
  'Deadline du projet': 'Fecha límite del proyecto',
  'Informations globales': 'Información general',
  'Contenu du projet': 'Contenido del proyecto',
  'Séléctionner le type de contenu': 'Seleccionar tipo de contenido',
  'Sélectionner un agent IA personnalisé': 'Seleccionar un agente IA personalizado',
  'Créer un agent IA personnalisé': 'Crear un agente IA personalizado',
  'Liens utiles': 'Enlaces útiles',
  'Rédacteur(s)': 'Redactor(es)',
  'Deadline': 'Fecha límite',
  'Nb textes': 'Nº de textos',
  'IA + Revue par rédacteur': 'IA + Revisión por redactor',
  'Ajouter un projet': 'Agregar proyecto',
  'Projets': 'Proyectos',
  'Non attribués': 'No asignados',
  'Rédaction IA': 'Redacción IA',
  'Résultats sur': 'Resultados en',
  'Êtes-vous sûr de vouloir supprimer cet agent IA ?': '¿Estás seguro de que deseas eliminar este agente IA?',
  'Mes agents IA': 'Mis agentes IA',
  'Tous': 'Todos',
  'Rédaction': 'Redacción',
  'Traduction': 'Traducción',
  'Rechercher': 'Buscar',
  'Sélectionner un site': 'Seleccionar un sitio',
  'Créer un agent IA personnalisé': 'Crear un agente IA personalizado',
  'Définissez la mission, le rôle, la langue, le type de contenu et plus encore.': 'Define la misión, el rol, el idioma, el tipo de contenido y mucho más.',
  'Nouvel agent': 'Nuevo agente',
  'Rôle :': 'Rol:',
  'Type de contenu :': 'Tipo de contenido:',
  'Langue :': 'Idioma:',
  'Siteweb :': 'Sitio web:',
  'GBP': 'GBP',
  'Sélectionner un LLM': 'Seleccionar un LLM',
  'Fiche produit smart': 'Ficha de producto inteligente',
  'Détails du texte': 'Detalles del texto',
  '(Mot clé*, URL, Balise titre, Balise méta-description)': '(Palabra clave*, URL, Etiqueta de título, Meta descripción)',
  'URL siteweb*': 'URL del sitio web*',
  'Balise titre': 'Etiqueta de título',
  'Balise méta-description': 'Meta descripción',
  'Sélectionner un site web': 'Seleccionar un sitio web',
  'Sélectionner un agent IA': 'Seleccionar un agente IA',
  'Lancer': 'Iniciar',
  'Relancer': 'Reiniciar',
  'Génération en cours...': 'Generando...',
  'Générer': 'Generar',
  'Enregistrement...': 'Guardando...',
  'Enregistrer ': 'Guardar',
  'Livrer': 'Entregar',
  'Livraison...': 'Entregando...',
  'En ligne...': 'En línea...',
  "Derniers contenus ajoutés": "Contenidos más recientes",


  'Nom de l\'agent': 'Nombre del agente',
  'Site web': 'Sitio web',
  'Mission': 'Misión',
  'Langue de traduction': 'Idioma de traducción',
  'Langue': 'Idioma',
  'Tonalité': 'Tono',
  'Cible / Audience': 'Objetivo / Audiencia',
  'Base de connaissance locale': 'Base de conocimientos local',
  'Base de connaissance en ligne': 'Base de conocimientos en línea',
  'Sélect. fichiers': 'Seleccionar archivos',
  'Ex: URL1, URL2': 'Ej: URL1, URL2',
  'Annuler': 'Cancelar',
  'Mettre à jour': 'Actualizar',
  'Valider': 'Validar',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages': 'Ej: un párrafo sobre los tipos de intervención, un párrafo sobre las ventajas',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels': 'ej: los paraguas plegables tienen apertura automática, los otros son manuales',
  '📚 Base de connaissances': '📚 Base de conocimientos',
  'Base de connaissance locale': 'Base de conocimientos local',
  'Base de connaissance en ligne': 'Base de conocimientos en línea',
  'Sélect. fichiers': 'Seleccionar archivos',
  'Ex: URL1, URL2': 'Ej: URL1, URL2',
  'Annuler': 'Cancelar',
  'Mettre à jour': 'Actualizar',
  'Valider': 'Validar',
  'Ex: un paragraphe sur les types d\'intervention, un paragraphe sur les avantages': 'Ej: un párrafo sobre los tipos de intervención, un párrafo sobre las ventajas',
  'ex : les parapluies pliant sont à ouverture automatique, les autres sont manuels': 'ej: los paraguas plegables tienen apertura automática, los otros son manuales',
  'Type de produits / services proposés par le site*': 'Tipo de productos / servicios ofrecidos por el sitio*',
  'Règles rédactionnelles': 'Reglas de redacción',
  'Lexique recommandé': 'Léxico recomendado',
  'Expressions interdites': 'Expresiones prohibidas',
  'Instructions de personnalisation': 'Instrucciones de personalización',
  'Base de connaissance en ligne': 'Base de conocimientos en línea',
  "🧩 Informations générales": "🧩 Información general",
  "🗣️ Ton & Audience": "🗣️ Tono y Audiencia",
  "📝 Structure & Rédaction": "📝 Estructura y Redacción",
  "📚 Base de connaissances": "📚 Base de conocimientos",
  "Structure de texte attendu": "Estructura de texto esperada",
  "Enrichissement SEO": "Enriquecimiento SEO",
  "traduction IA": "Traducción IA",
  "Traduction en cours...": "Traducción en curso...",
  "Traduire": "Traducir",
  "Créer votre assistant éditorial sur mesure": "Cree su asistente editorial a medida",
  "Votre texte traduit": "Su texto traducido",
  "Détail du projet": "Detalle del proyecto",
  "Détail d'attribution": "Detalle de asignación",
  "Détail des contenus": "Detalle de los contenidos",



  "Nom agent": "Nombre del agente",
  "Rédaction": "Redacción",
  "Traduction": "Traducción",
  'Mots clé': 'Palabras clave',
  'Url de la page': 'URL de la página',
  'Entrez le mot clé principal': 'Ingrese la palabra clave principal',
  'Entrez l url': 'Ingrese la URL',
  'Date d\'ajout': 'Fecha de incorporación',
  'Dernière mise à jour': 'Última actualización',
  'URL': 'URL',
  'Status': 'Estado',
  'Actions': 'Acciones',
  'Détails du texte': 'Detalles del texto',
  "Contenus disponibles": "Contenidos disponibles",
  "Textes générés": "Textos generados",



  "'Veuillez d'abord sélectionner un site web": "Por favor seleccione primero un sitio web",
  "Chargement des agents...": "Cargando agentes...",
  "Aucun agent disponible pour ce site": "Ningún agente disponible para este sitio",
  "Sélectionner...": "Seleccionar...",
  "Modifier cet agent": "Modificar este agente",
  "Créer un agent IA personnalisé": "Crear un agente de IA personalizado",
  "Créer un agent IA personnalisé": "Crear un agente de IA personalizado",
  "Rédaction en cours...": "Redacción en curso...",
  "Génération en cours": "Generación en curso",
  "Rédiger un contenu": "Redactar un contenido",
  "Rédiger un lot de contenus": "Redactar un lote de contenidos",
  "Url page": "URL de la página",
  "Entrez l'URL cible de votre contenu (facultatif).": "Ingrese la URL objetivo de su contenido (opcional).",
  "GAP sémantique": "Brecha semántica",
  "keyword1 (2),\nkeyword2 (1),\nkeyword3 (1),\nkeyword4 (2),\n.....": "palabraclave1 (2),\npalabraclave2 (1),\npalabraclave3 (1),\npalabraclave4 (2),\n.....",
  "Maillage interne": "Enlazado interno",
  "Introduisez le maillage": "Introduzca el enlazado interno",
  "Introduisez le maillage interne": "Introduzca el enlazado interno",
  "Importer un fichier contenant la liste des thématiques à rédiger et l'IA fera le reste 😊": "Importe un archivo con la lista de temas a redactar y la IA hará el resto 😊",
  "Importer": "Importar",
  "Saisissez le mot-clé principal de votre contenu.": "Ingrese la palabra clave principal de su contenido.",
  "Texte à traduire": "Texto a traducir",
  "Saisissez le texte à traduire": "Ingrese el texto a traducir",
  "Traduire un contenu": "Traducir un contenido",
  "Traduire un lot de contenus": "Traducir un lote de contenidos",
  "Importer un fichier contenant la liste des textes à traduire et l'IA fera le reste 😊": "Importe un archivo con la lista de textos a traducir y la IA hará el resto 😊",
  "Commencer la traduction": "Comenzar la traducción",
  "Lancer la traduction": "Iniciar la traducción",
  "Commencer la rédaction": "Comenzar la redacción",
  "Lancer la rédaction": "Iniciar la redacción",

  "En ligne...": "En línea...",
  "Ajouter un nouveau site web": "Agregar un nuevo sitio web",
  "Créer": "Crear",
  "Séléctionner ou ajoutez les thématiques qui reflètent votre expertise.": "Seleccione o agregue las temáticas que reflejen su experiencia.",
  "Ajoutez ou sélectionnez une thématique": "Agregue o seleccione una temática",
  "Le site web a été créé avec succès": "El sitio web se ha creado con éxito",
  "Nous configurons actuellement vos agents IA. Ils seront bientôt prêts à vous assister dans la génération de vos contenus.": "Actualmente estamos configurando sus agentes de IA. Pronto estarán listos para asistirle en la generación de su contenido.",
  "Derniers contenus ajoutés": "Últimos contenidos agregados",
  "Tous les sites": "Todos los sitios",
  "Sélectionner le site web": "Seleccionar el sitio web",
  "Aucun fichier sélectionné": "Ningún archivo seleccionado",
  "ex : utilise le vouvoiement, utilise un vocabulaire compréhensible par la cible": "ej.: use un tono formal y vocabulario comprensible para el público objetivo.",
  "🧠 Créer un agent IA": "🧠 Crear un agente IA",
  "🧠 Modifier un agent IA": "🧠 Modificar un agente IA",
  "Ex : AMF (Autorité des Marchés Financiers).": "Ej.: AMF (Autoridad de los Mercados Financieros).",
  "Ex: bio, écologique, nom des concurrents": "Ej.: bio, ecológico, nombres de competidores.",
  "Détailler le plus possible la structure attendue à l'aide d'axes de rédaction pour guider l'IA sur les sujets à traiter et dans quel ordre": "Detalla lo más posible la estructura esperada usando ejes de redacción para guiar a la IA sobre los temas a tratar y su orden.",
  "Ajouter des éléments que l'IA doit ou ne pas faire ou mentionner": "Agregue elementos que la IA debe o no debe hacer o mencionar.",
  "Ex: prêt-à-porter féminin": "Ej.: moda prêt-à-porter femenina",
  "Ex: Rédacteur SEO": "Ej.: Redactor SEO",
  "Indiquer la liste des urls sur lesquels l'IA peut s'appuyer": "Indique la lista de URLs en las que la IA puede apoyarse.",
  "Créez, optimisez, performez : votre contenu prend une nouvelle dimension.": "Cree, optimice, mejore: su contenido alcanza una nueva dimensión.",
  "La création de contenu n'a jamais été aussi smart.": "La creación de contenido nunca ha sido tan inteligente.",
  "Boostez votre productivité grâce à la puissance multi-IA. Comparez et combinez les meilleures propositions issues de plusieurs LLM, puis optimisez-les grâce à un score de contenu en temps réel (SEO, lisibilité, pertinence)": "Impulse su productividad gracias al poder de múltiples IA. Compare y combine las mejores propuestas de varios LLM y optimícelas con una puntuación de contenido en tiempo real (SEO, legibilidad, relevancia).",
  "Je crée mon premier contenu SEO friendly": "Creo mi primer contenido optimizado para SEO",
  "Veuillez coller le texte source....": "Por favor, pegue el texto fuente...",
  "Enrichir": "Enriquecer",
  "Veuillez d'abord sélectionner un site web": "Por favor, seleccione primero un sitio web.",
  "🎯 Commencez ici": "🎯 Comience aquí",
  "Ajoutez ou sélectionnez le site web que vous souhaitez suivre.": "Agregue o seleccione el sitio web que desea seguir.",
  "📝 Derniers contenus créés": "📝 Últimos contenidos creados",
  "Retrouvez ici les derniers contenus créés pour le site sélectionné.": "Encuentre aquí los últimos contenidos creados para el sitio seleccionado.",
  "Cliquez sur un texte pour consulter sa fiche détaillée.": "Haga clic en un texto para ver su ficha detallada.",
  "📁 Derniers projets créés": "📁 Últimos proyectos creados",
  "Accédez rapidement aux derniers projets lancés pour ce site.": "Acceda rápidamente a los últimos proyectos lanzados para este sitio.",
  "Cliquez sur un projet pour voir son avancement et les contenus associés.": "Haga clic en un proyecto para ver su avance y los contenidos asociados.",
  "📊 Suivi de vos projets": "📊 Seguimiento de sus proyectos",
  "Visualisez la répartition de vos projets : en cours, en retard ou validés.": "Visualice la distribución de sus proyectos: en curso, retrasados o validados.",
  "Une vue d’ensemble claire pour suivre l’état global de votre production.": "Una vista general clara para seguir el estado global de su producción.",
  "📑 Statut d’avancement des contenus": "📑 Estado de avance de los contenidos",
  "Suivez ici la répartition de vos contenus : brouillons, livrés et publiés.": "Siga aquí la distribución de sus contenidos: borradores, entregados y publicados.",
  "Idéal pour identifier rapidement où concentrer vos efforts.": "Ideal para identificar rápidamente dónde concentrar sus esfuerzos.",
  "📅 Textes publiés par mois": "📅 Textos publicados por mes",
  "Visualisez le nombre de textes publiés chaque mois pour le site sélectionné.": "Visualice el número de textos publicados cada mes para el sitio seleccionado.",
  "Suivez ainsi votre rythme de déploiement dans le temps.": "Así, siga su ritmo de publicación a lo largo del tiempo.",
  "⭐ Top mots-clés": "⭐ Principales palabras clave",
  "Découvrez vos 5 mots-clés les plus performants issus de la Search Console.": "Descubra sus 5 palabras clave más destacadas de Search Console.",
  "Comparez leur position, les clics actuels et les clics de l’année précédente.": "Compare su posición, clics actuales y clics del año anterior.",
  "📈 Activer le suivi du trafic": "📈 Activar seguimiento del tráfico",
  "Ajoutez notre adresse e-mail à votre Search Console pour activer cette analyse.": "Agregue nuestra dirección de correo electrónico a su Search Console para activar este análisis.",
  "Vous pourrez ensuite suivre l’évolution de votre trafic directement dans Typix.": "Luego podrá seguir la evolución de su tráfico directamente en Typix.",
  "🏠 Tableau de bord": "🏠 Panel de control",
  "Revenez à la vue globale : indicateurs clés, contenus récents, projets et performances de votre site.": "Vuelva a la vista global: indicadores clave, contenidos recientes, proyectos y rendimiento de su sitio.",
  "🤖 Agents IA": "🤖 Agentes IA",
  "Configurez et pilotez vos agents IA pour automatiser la rédaction ainsi que la traduction et gagner du temps sur vos contenus.": "Configure y gestione sus agentes IA para automatizar la redacción y traducción, ahorrando tiempo en su contenido.",
  "✍️ Rédaction IA": "✍️ Redacción IA",
  "Accédez aux générateurs IA : fiches produit, fiches GMB, pages catégories et autres contenus optimisés.": "Acceda a los generadores IA: fichas de producto, fichas GMB, páginas de categorías y otros contenidos optimizados.",
  "🌍 Traduction IA": "🌍 Traducción IA",
  "Traduisez vos contenus en plusieurs langues en quelques clics tout en conservant la cohérence SEO.": "Traduzca su contenido a varios idiomas en unos pocos clics manteniendo la coherencia SEO.",
  "➕ Créer un projet": "➕ Crear un proyecto",
  "Lancez un nouveau projet de contenus en quelques secondes et suivez ensuite son avancement.": "Lance un nuevo proyecto de contenido en segundos y luego siga su avance.",
  "📂 Gestion des projets": "📂 Gestión de proyectos",
  "Accédez à vos projets non attribués, en cours, en retard ou validés pour suivre leur progression.": "Acceda a sus proyectos no asignados, en curso, retrasados o validados para seguir su progreso.",
  "👤 Mon profil": "👤 Mi perfil",
  "Modifiez vos informations personnelles.": "Modifique su información personal.",
  "🧑‍🤝‍🧑 Gestion des utilisateurs": "🧑‍🤝‍🧑 Gestión de usuarios",
  "Invitez de nouveaux membres, gérez leurs droits et organisez les équipes.": "Invite a nuevos miembros, gestione sus derechos y organice los equipos.",
  "❓ Mon guide": "❓ Mi guía",
  "Relancez ce guide interactif à tout moment pour retrouver les principales fonctionnalités de Typix.": "Reinicie esta guía interactiva en cualquier momento para encontrar las principales funcionalidades de Typix.",
  "Mon guide": "Mi guía",
  "Se déconnecter": "Cerrar sesión",
  "L'adresse email est obligatoire.": "El correo electrónico es obligatorio.",
  "Le nom est obligatoire.": "El apellido es obligatorio.",
  "Le prénom est obligatoire.": "El nombre es obligatorio.",
  "Le mot de passe est obligatoire.": "La contraseña es obligatoria.",
  "La confirmation est obligatoire.": "La confirmación es obligatoria.",
  "Les mots de passe ne correspondent pas.": "Las contraseñas no coinciden.",
  "Récapitulatif": "Resumen",
  "Quitter la création": "Salir de la creación",
  "Objectif du projet": "Objetivo del proyecto",
  "Mode de production": "Modo de producción",
  "Répartition du travail": "Distribución del trabajo",
  "Contexte éditorial": "Contexto editorial",
  "Rédaction": "Redacción",
  "Traduction": "Traducción",
  "Créer du contenu original": "Crear contenido original",
  "Traduire un contenu existant": "Traducir contenido existente",
  "Identification du projet": "Identificación del proyecto",
  "Nom du projet": "Nombre del proyecto",
  "Vous pourrez modifier le nom plus tard": "Podrá modificar el nombre más tarde",
  "URL du site": "URL del sitio",
  "Langue": "Idioma",
  "Sélectionner une langue": "Seleccionar un idioma",
  "Nombre de textes": "Número de textos",
  "12 textes disponibles": "12 textos disponibles",
  "Chef de projet": "Jefe de proyecto",
  "Aucun chef de projet assigné au siteweb": "Ningún jefe de proyecto asignado al sitio web",
  "Sélectionner un chef de projet": "Seleccionar un jefe de proyecto",
  "Date limite du projet": "Fecha límite del proyecto",
  "Sélectionner une date limite": "Seleccionar una fecha límite",
  "Suivant": "Siguiente",
  "Retour": "Volver",
  "Définissez l'objectif et le cadre général de votre projet.": "Defina el objetivo y el marco general de su proyecto.",
  "IA": "IA",
  "Production généré par IA": "Producción generada por IA",
  "Rédacteur": "Redactor",
  "Production Rédacteur par IA": "Producción de redactor por IA",
  "IA + revue humaine": "IA + revisión humana",
  "IA avec validation humaine.": "IA con validación humana.",
  "Répartissez les textes de votre projet entre vous et d'éventuels rédacteurs.": "Distribuya los textos de su proyecto entre usted y posibles redactores.",
  "L'attribution à un rédacteur est optionnelle.": "La asignación a un redactor es opcional.",
  "Agent IA": "Agente IA",
  "Vous pourrez changer d'agent plus tard": "Podrá cambiar de agente más tarde",
  "Veuillez d'abord sélectionner un site web": "Por favor, seleccione primero un sitio web",
  "Sélectionnez le mode IA": "Seleccione el modo IA",
  "Aucun agent disponible": "Ningún agente disponible",
  "Sélectionner un agent IA": "Seleccionar un agente IA",
  "Format du contenu": "Formato del contenido",
  "Sélectionner un format": "Seleccionar un formato",
  "Nombre de mots par texte": "Número de palabras por texto",
  "Format personnalisé": "Formato personalizado",
  "définir le nombre de mots": "definir el número de palabras",
  "mots": "palabras",
  "Options avancées": "Opciones avanzadas",
  "Enrichissement du contenu": "Enriquecimiento del contenido",
  "Génération Image": "Generación de Imágenes",
  "Nombre d’images": "Número de Imágenes",
  "Définir le nombre d’images": "Definir el número de imágenes",
  "Consomment des crédits supplémentaires": "Consumen créditos adicionales",
  "IA augmentée par vos données": "IA mejorada con sus datos",
  "Sélectionnez les personnes en charge de la relecture des contenus générés par l'IA et répartissez": "Seleccione las personas responsables de la revisión de los contenidos generados por IA y distribuya",
  "les textes à valider.": "los textos a validar.",
  "Le relecteur peut apporter des corrections et ajustements ciblés dans la limite de mots définie,": "El revisor puede realizar correcciones y ajustes específicos dentro del límite de palabras definido,",
  "sans réécrire entièrement le contenu.": "sin reescribir completamente el contenido.",
  "Contexte éditorial & brief détaillé du projet": "Contexto editorial y brief detallado del proyecto",
  "Ajouter des informations contextuelles pour guider et enrichir la production des contenus.": "Agregue información contextual para guiar y enriquecer la producción de contenidos.",
  "Gap sémantique": "Brecha semántica",
  "optionnel": "opcional",
  "Brief détaillé": "Brief detallado",
  "Lien drive...": "Enlace drive...",
  "Lancer le projet": "Lanzar el proyecto",
  "Nom du projet existant": "El nombre del proyecto ya existe",
  "Un projet avec ce nom existe déjà dans votre espace.": "Ya existe un proyecto con este nombre en su espacio.",
  "Merci de choisir un nom différent pour continuer.": "Por favor, elija un nombre diferente para continuar.",
  "Erreur lors de la création du projet. Veuillez réessayer.": "Error al crear el proyecto. Por favor, inténtelo de nuevo.",
  "Félicitations !": "¡Felicitaciones!",
  "Votre projet a été créé avec succès !": "¡Su proyecto ha sido creado con éxito!",
  "Voir le projet": "Ver el proyecto",
  "Paramètres du compte": "Configuración de la cuenta",
  "Fermer": "Cerrar",
  "Site web": "Sitio web",
  "Langue du site": "Idioma del sitio",
  "textes": "textos",
  "Deadline": "Fecha límite",
  "Type": "Tipo",
  "Rédacteur": "Redactor",
  "Moi (par défaut)": "Yo (por defecto)",
  "Livraison le": "Entrega el",
  "À venir": "Próximamente",
  "Production généré par IA": "Producción generada por IA",
  "Agent": "Agente",
  "Format": "Formato",
  "Enrichissement du contenu activé": "Enriquecimiento del contenido activado",
  "Relecteur": "Revisor",
  "texte": "texto",
  "Limite de modification": "Límite de modificación",
  "Aucune attribution": "Sin asignación",
  "Aucun élément ajouté": "Ningún elemento añadido",
  "janvier": "enero",
  "février": "febrero",
  "mars": "marzo",
  "avril": "abril",
  "mai": "mayo",
  "juin": "junio",
  "juillet": "julio",
  "août": "agosto",
  "septembre": "septiembre",
  "octobre": "octubre",
  "novembre": "noviembre",
  "décembre": "diciembre",
  "à": "hasta",
  "mots minimum": "mínimo de palabras",
  "mots maximum": "máximo de palabras",
  "Sans titre": "Sin título",
  "Status de validation des projets": "Estado de validación de los proyectos",
  "Statut d'avancement des contenus:": "Estado de avance de los contenidos:",
  "Total des contenus :": "Total de contenidos:",
  "Non attribué": "No asignado",
  "Évolution des performances": "Evolución del rendimiento",
  "Espace de travail AI": "Espacio de trabajo de IA",
  "Mise à jour 1.2": "Actualización 1.2",
  "Découvrez les dernières fonctionnalités, optimisations et correctifs.": "Descubre las últimas funcionalidades, optimizaciones y correcciones.",
  "Projet créé": "Proyecto creado",
  "Votre projet a bien été créé.": "Tu proyecto ha sido creado correctamente.",
  "Vous pouvez commencer à travailler dessus dès maintenant.": "Puedes empezar a trabajar en él ahora mismo.",
  "Sélectionnez le mode IA": "Seleccione el modo IA",
  "Aucun agent disponible": "Ningún agente disponible",
  "Sélectionner un agent IA": "Seleccionar un agente IA",
  "Sélectionner un format": "Seleccionar un formato",
  "Veuillez d'abord sélectionner un site web": "Por favor, seleccione primero un sitio web.",

  'Nouveau contenu': 'Nuevo contenido',
  'Génération en cours...': 'Generación en curso...',
  'Optimisation en cours...': 'Optimización en curso...',
  'Traduction en cours...': 'Traducción en curso...',
  'En lignes': 'En línea',
  'filtres': 'Filtros',
  'trier par': 'Ordenar por',
  'Score décroissant': 'Puntuación descendente',
  'Score croissant': 'Puntuación ascendente',
  'Date de création': 'Fecha de creación',
  'Date de mise à jour': 'Fecha de actualización',
  'Date récente': 'Fecha más reciente',
  'Date ancienne': 'Fecha más antigua',
  'Mots clés': 'Palabras clave',
  'Éditeur': 'Editor',
  'Créateur': 'Creador',
  'Rédacteurs': 'Redactores',
  'Réinitialisé par défaut': 'Restablecer valores predeterminados',
  'Mode de rédaction': 'Modo de redacción',
  'Agent AI utilisé': 'Agente de IA utilizado',
  'Textes en brouillons': 'Borradores',
  'Modèle': 'Modelo',
  'Paramètres du projet': 'Configuración del proyecto',
  'Avancement': 'Estado',
  'Progression': 'Progreso',
  'Aucun texte disponible': 'No hay texto disponible',
  'Détails du projet': 'Detalles del proyecto',
  'Page {{current}} sur {{total}}': 'Página {{current}} de {{total}}',
  'Moteur LLM': 'Motor LLM',
  'Rédiger un contenu': 'Redactar contenido',
  'Traduire un contenu': 'Traducir contenido',
  'Optimiser un contenu': 'Optimizar contenido',
  'Générer un contenu': 'Generar contenido',

  'Créez un texte pour un mot-clé spécifique avec un formulaire guidé':
    'Crea un texto para una palabra clave específica con un formulario guiado',

  'Traduire un texte spécifique avec un formulaire guidé':
    'Traducir un texto específico con un formulario guiado',

  'Générez plusieurs textes en important un fichier Excel':
    'Generar varios textos importando un archivo Excel',

  'Rédiger un lot de contenus': 'Redactar un lote de contenidos',
  'Traduire un lot de contenus': 'Traducir un lote de contenidos',
  'Enrichir un contenu': 'Enriquecer contenido',

  'Optimisez un texte spécifique avec un formulaire guidé':
    'Optimizar un texto específico con un formulario guiado',

  'Nombre total de textes alloués au projet':
    'Número total de textos asignados al proyecto',

  'Vous pourrez changer le format du contenu plus tard':
    'Podrá cambiar el formato del contenido más tarde',

  'Saisissez chaque mot-clé suivi de sa fréquence entre parenthèses, puis appuyez sur Entrée. Exemple : chaussures(3)':
    'Ingrese cada palabra clave seguida de su frecuencia entre paréntesis y presione Enter. Ejemplo: zapatos(3)',

  'Ex: voiture(5), électrique(3), autonomie(8)':
    'Ej.: coche(5), eléctrico(3), autonomía(8)',

  'URLs des pages à lier (séparées par des virgules)':
    'URLs de las páginas a enlazar (separadas por comas)',

  'Besoin d\'aide pour préparer votre fichier ?':
    '¿Necesita ayuda para preparar su archivo?',

  'Télécharger le modèle (Excel)':
    'Descargar plantilla (Excel)',

  'Déposez votre fichier ici':
    'Suelte su archivo aquí',

  'Glissez-déposez votre fichier Excel':
    'Arrastre y suelte su archivo Excel',

  'ou cliquez pour parcourir':
    'o haga clic para buscar',

  'Formats acceptés : .xlsx, .xls (max 10 Mo)':
    'Formatos aceptados: .xlsx, .xls (máx. 10 MB)',

  'Parcourir les fichiers':
    'Buscar archivos',

  'Ex: télépéage automatique':
    'Ej.: peaje automático',

  'Générer le contenu': 'Generar contenido',
  'Lancer la génération': 'Iniciar generación',
  'Commencer la traduction': 'Iniciar traducción',
  'Lancer la traduction': 'Iniciar traducción',

  'Partager': 'Compartir',
  'Telecharger le texte': 'Descargar texto',
  'Modifier le projet': 'Editar proyecto',
  'Modifiez les détails de votre projet ici.':
    'Edite los detalles de su proyecto aquí.',

  'Général': 'General',
  'Allocation des textes': 'Asignación de textos',
  'Sélectionner un format du contenu': 'Seleccionar un formato de contenido',
  'Allocation aux rédacteurs': 'Asignación a redactores',

  '{{count}} textes disponibles':
    '{{count}} textos disponibles',

  'Sélectionner un rédacteur': 'Seleccionar un redactor',
  'Nom du rédacteur': 'Nombre del redactor',
  'Date limite': 'Fecha límite',
  'texte restant': 'textos restantes',
  'textes alloués': 'textos asignados',

  'Article court - 300 mots': 'Artículo corto – 300 palabras',
  'Article moyen - 600 mots': 'Artículo medio – 600 palabras',
  'Article long - 1000 words': 'Artículo largo – 1000 palabras',
  'Youtube - 350 mots': 'YouTube – 350 palabras',
  'Linkedin - 200 mots': 'LinkedIn – 200 palabras',
  'X - 150 mots': 'X – 150 palabras',
  'Personnalisé': 'Personalizado',

  'Voir plus': 'Ver más',
  ' à votre ': ' en su ',
  '{{count}} textes à livrer':
    '{{count}} textos por entregar',

'Nous contacter': 'Contáctenos',
'Vous avez une question ou un problème ? Contactez-nous et nous vous répondrons dans les plus brefs délais.': '¿Tiene alguna pregunta o problema? Contáctenos y le responderemos lo antes posible.',
'Sujet': 'Asunto',
'Message': 'Mensaje',
'Soumettre ma demande': 'Enviar mi solicitud',
'Veuillez sélectionner un sujet': 'Por favor seleccione un asunto',
'Décrivez votre demande en détail...': 'Describa su solicitud en detalle...',
'Sélectionnez un sujet': 'Seleccione un asunto',
'Autre': 'Otro',
'Feedback': 'Retroalimentación',
'Question': 'Pregunta',
'Bug': 'Error',
'Le message doit contenir au moins 10 caractères': 'El mensaje debe contener al menos 10 caracteres',
'Votre message a été envoyé avec succès. Nous vous répondrons dans les plus brefs délais.': 'Su mensaje ha sido enviado con éxito. Le responderemos lo antes posible.',
'Votre demande a bien été transmise à notre équipe support, qui vous répondra dans les plus brefs délais.': 'Su solicitud ha sido enviada a nuestro equipo de soporte, que le responderá lo antes posible.',
'Envoi en cours...': 'Enviando...',
'Fermer': 'Cerrar',
'Créer un nouvel agent AI': 'Crear un nuevo agente AI',
'Mission de l\'agent': 'Misión del agente',
'L\'agent générera du contenu original à partir de vos consignes.': 'El agente generará contenido original basado en tus instrucciones.',
'Informations générales': 'Información general',
'Informations principales': 'Información principal',
'Ton & audience': 'Tono y audiencia',
'Structure & rédaction': 'Estructura y redacción',
'Base de connaissances': 'Base de conocimientos',
'Construction du contenu': 'Construcción de contenido',
'Structure attendu': 'Estructura esperada',
'Cadre lexical': 'Marco léxico',
'Personnalisation avancée': 'Personalización avanzada',
'Base de connaissance locale en ligne': 'Base de conocimientos local en línea',
'Glissez-déposez votre fichier': 'Arrastra y suelta tu archivo',
'Base de connaissance': 'Base de conocimientos',
'Indiquez la liste des urls sur lesquels l’IA peut s’appuyer': 'Indica la lista de URLs en las que la IA puede apoyarse',
'Définissez le positionnement éditorial de votre agent afin qu’il adapte son ton,': 'Define el posicionamiento editorial de tu agente para que adapte su tono,',
'sa cible et son vocabulaire à votre activité.': 'su público objetivo y su vocabulario a tu actividad.',
'caractères': 'caracteres',
};
